export default class Trasa {

    public id: string;
    public name: string;

    public clone(): Trasa {
        const newDen: Trasa = new Trasa();
        newDen.loadFromEntity(this);
        return newDen;
    }

    public loadFromJSON(json: any): Trasa {
        this.id = json.id;
        this.name = json.name;
        return this;
    }

    public loadFromEntity(ent: Trasa): Trasa {
        this.id = ent.id;
        this.name = ent.name;
        return this;
    }

}


// WEBPACK FOOTER //
// ./src/models/Trasa.tsx